import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import ConfirmDialog from './ConfirmDialog'
import { closeConfirmDialog } from '@app-core/app/actions'

class ConfirmDialogContainer extends PureComponent {
  _onClose = () => {
    const { afterClose, closeConfirmDialog } = this.props
    closeConfirmDialog()
    afterClose()
  }

  _onSure = () => {
    const { onSure, afterSure, closeConfirmDialog } = this.props
    onSure()
    afterSure()
    closeConfirmDialog()
  }

  render() {
    const { isOpen, title, content, sureButtonTitle, cancelButtonTitle } = this.props
    return (
      isOpen && (
        <ConfirmDialog
          title={title}
          content={content}
          onSure={this._onSure}
          onClose={this._onClose}
          sureButtonTitle={sureButtonTitle}
          cancelButtonTitle={cancelButtonTitle}
        />
      )
    )
  }
}

const mapStateToProps = (state) => ({
  isOpen: state.app.getIn(['confirmDialog', 'isOpen']),
  title: state.app.getIn(['confirmDialog', 'title']),
  content: state.app.getIn(['confirmDialog', 'content']),
  sureButtonTitle: state.app.getIn(['confirmDialog', 'sureButtonTitle']),
  cancelButtonTitle: state.app.getIn(['confirmDialog', 'cancelButtonTitle']),
  onSure: state.app.getIn(['confirmDialog', 'onSure']),
  afterClose: state.app.getIn(['confirmDialog', 'afterClose']),
  afterSure: state.app.getIn(['confirmDialog', 'afterSure']),
})

export default connect(mapStateToProps, {
  closeConfirmDialog,
})(ConfirmDialogContainer)
